var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.51 147.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9a5b3a;}.cls-2{fill:#aa6441;}.cls-3{fill:#231f20;}.cls-4{fill:none;stroke:#602413;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-5{fill:#9f1d2e;}.cls-6{fill:#cb4a45;}.cls-7{fill:#fff;}.cls-8{fill:#8a4931;}.cls-9{fill:#3c2415;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tobi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.26,80.17c-2.38-1.74-4.84-3.53-7.69-4.26S3.31,75.74,1.47,78A7.71,7.71,0,0,0,0,83a20.56,20.56,0,0,0,1,5.19A43.57,43.57,0,0,0,5.13,98.45,18.91,18.91,0,0,0,13,106a12.11,12.11,0,0,0,10.68.06c.39-.2-.06-1.41-.1-1.84C23.05,99.6,17.26,80.17,17.26,80.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.29,102c.18,19.41-11.52,25.54-17.82,29.21C93.14,141.3,74.36,149.08,56,146.7,36.45,144.16,9.28,117.56,9.28,80.33S16.94,7.92,76.69,7.92C141,7.92,128,64.74,128.29,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.78,34.21c3.54-.37,30.43-8.47,31.32-5.27,4.48,16.11,2,52.2,3.92,59,0,3.17,10.21-19.78,21-17,6.48-17.29-.62-35.48-8.21-48.53C126.72,6.88,102.66,0,73.54,0,54.6,0,29.28,2,20.39,17.14c-8.6,17.57-13,32.35-11.11,58.58,2.34-24.27,3.57-31.39,14.55-47.39C34.05,30.71,34.8,39.78,87.78,34.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.94,102c5.14-9.26,16.82-9.16,21.32,0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mouth"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35,116.13a177.77,177.77,0,0,0,24,1.77,119.47,119.47,0,0,0,21.31-1.77s-3.55,15.26-21.81,15.26C40.69,131.39,35,116.13,35,116.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.49,128.57a25.52,25.52,0,0,0,12,2.82,25.13,25.13,0,0,0,10.38-2C62.5,123.66,52.59,121.94,46.49,128.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M46.22,121.15c10.47-.71,24.42,3.14,25.77-3.88-3.5.34-7.93.63-13,.63-6,0-11.8-.41-16.18-.83C43.67,119.58,44.43,121.15,46.22,121.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.19,78.31c2.47-5.18,8.4-7,11.6-7.77s7-.19,9.07,2.4a8.6,8.6,0,0,1,1.65,5.58,22.82,22.82,0,0,1-1.13,5.81,48.93,48.93,0,0,1-4.62,11.48,21.11,21.11,0,0,1-8.81,8.48,13.6,13.6,0,0,1-12,.08c-.44-.24.06-1.58.12-2.07C123.67,97.1,127.19,78.31,127.19,78.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.92,81.44c-2.62-4.59-4-2.29-9.79.46-2.41,7.55,8.94,6.82-4.62,17.3C137.59,96.64,146,89.4,142.92,81.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Right_Eye",
    "data-name": "Right Eye"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.25,73.27S44.05,81,35,81c-8.46,0-13.29-7.68-13.29-7.68s4.76-9.62,12.85-9.62C42.91,63.65,48.25,73.27,48.25,73.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.14,73c-2.78-3.36-7.58-7.74-13.78-7.74-5.34,0-9.46,3.5-12.09,6.64,1.57-2.57,5.86-8.45,12.18-8.45C42.39,63.41,47.6,72,48.14,73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 36.88,
    cy: 73.27,
    r: 7.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.39,
    cy: 73.27,
    r: 4.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 33.61,
    cy: 70.93,
    rx: 2.11,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.62,69.15a25,25,0,0,0-3.06-3.35,11.34,11.34,0,0,0-3.51-2,24.4,24.4,0,0,0-4-1c-1.4-.27-2.87-.43-4.24-.56a32.73,32.73,0,0,0-8.46.56,49.49,49.49,0,0,0-8.65,2.59,18.51,18.51,0,0,1,7.68-5.73A21.35,21.35,0,0,1,37.07,58c.82.1,1.67.18,2.47.32s1.59.32,2.38.55a17.79,17.79,0,0,1,4.63,2,10.48,10.48,0,0,1,3.6,3.68A12.28,12.28,0,0,1,51.62,69.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEft_Eye",
    "data-name": "LEft Eye"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.85,73.27S88.65,81,79.56,81c-8.46,0-13.29-7.68-13.29-7.68S71,63.65,79.11,63.65C87.51,63.65,92.85,73.27,92.85,73.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.73,73C90,69.6,85.15,65.22,79,65.22c-5.34,0-9.46,3.5-12.09,6.64,1.57-2.57,5.86-8.45,12.18-8.45C87,63.41,92.19,72,92.73,73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 81.47,
    cy: 73.27,
    r: 7.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.98,
    cy: 73.27,
    r: 4.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 78.21,
    cy: 70.93,
    rx: 2.11,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.22,69.15a26.4,26.4,0,0,0-3.06-3.35,11.39,11.39,0,0,0-3.52-2,24.54,24.54,0,0,0-4-1c-1.41-.27-2.87-.43-4.24-.56a32.7,32.7,0,0,0-8.46.56,49.24,49.24,0,0,0-8.65,2.59,18.39,18.39,0,0,1,7.68-5.73A21.3,21.3,0,0,1,81.67,58c.82.1,1.66.18,2.46.32s1.59.32,2.38.55a18,18,0,0,1,4.64,2,10.56,10.56,0,0,1,3.6,3.68A12.46,12.46,0,0,1,96.22,69.15Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset14);
export default __webpack_public_path__ + "static/media/asset14.715c2d98c37ff00cb5f85d5e32e50c88.svg";
export { ForwardRef as ReactComponent };